var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-footer',{attrs:{"height":"70px"}},[_c('div',{staticClass:"footer"},[_c('p',{staticClass:"p2"},[_vm._v(" 服务支持：金色大田科技有限公司 ")])])])}
var staticRenderFns = []

export { render, staticRenderFns }